import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-close\"><defs><style type=\"text/css\"></style></defs><path d=\"M851.776 100.928a64 64 0 0 1 93.952 86.592l-5.504 5.952-768 734.72a64 64 0 0 1-93.952-86.592l5.504-5.888 768-734.72z\" p-id=\"5603\" /><path d=\"M81.728 102.976a64 64 0 0 1 84.352-7.232l6.144 5.184 768 734.784a64 64 0 0 1-82.304 97.664l-6.144-5.12-768-734.784a64 64 0 0 1-2.048-90.496z\" p-id=\"5604\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol